/**
 * @generated SignedSource<<a4151c6e4a45dd605b0c9d42426ee4d4>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type PictureDialogChooseMutation$variables = {
  preset: string;
};
export type PictureDialogChooseMutation$data = {
  readonly chooseLearnerPicture: {
    readonly learner: {
      readonly id: string;
      readonly picture: {
        readonly preset: string | null | undefined;
        readonly url: string | null | undefined;
      } | null | undefined;
    } | null | undefined;
  };
};
export type PictureDialogChooseMutation = {
  response: PictureDialogChooseMutation$data;
  variables: PictureDialogChooseMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "preset"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "preset",
        "variableName": "preset"
      }
    ],
    "concreteType": "LearnerPicturePayload",
    "kind": "LinkedField",
    "name": "chooseLearnerPicture",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Learner",
        "kind": "LinkedField",
        "name": "learner",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "LearnerPicture",
            "kind": "LinkedField",
            "name": "picture",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "preset",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "url",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "PictureDialogChooseMutation",
    "selections": (v1/*:: as any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "PictureDialogChooseMutation",
    "selections": (v1/*:: as any*/)
  },
  "params": {
    "cacheID": "05b172bf317a11d232eebd11bf8c4a3f",
    "id": null,
    "metadata": {},
    "name": "PictureDialogChooseMutation",
    "operationKind": "mutation",
    "text": "mutation PictureDialogChooseMutation(\n  $preset: String!\n) {\n  chooseLearnerPicture(preset: $preset) {\n    learner {\n      id\n      picture {\n        preset\n        url\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "f1467b9bc262a5ba233719856fc1ee2a";

export default node;
